import "@/assets/scss/schooldock.scss";
import '@fortawesome/fontawesome-free/css/all.min.css'

import "@/assets/slider.css";
import "@/assets/spinner.css";
import "@/assets/workspace.css";
import "@/assets/subscription-ui.css";
import 'animate.css';
import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives";

import SidebarPlugin from "@/components/SidebarPlugin/index"





export default {
  install(Vue) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
    Vue.use(SidebarPlugin);   
    Vue.use(require('vue-moment'));
  }
};
